/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactValidationDto } from '../../models/contact-validation-dto';
import { FindEmailResponseDto } from '../../models/find-email-response-dto';

export interface PostUserControllerFindEmail$Params {
      body: ContactValidationDto
}

export function postUserControllerFindEmail(http: HttpClient, rootUrl: string, params: PostUserControllerFindEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FindEmailResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, postUserControllerFindEmail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FindEmailResponseDto>>;
    })
  );
}

postUserControllerFindEmail.PATH = '/api/user/find/email';
